import { render, staticRenderFns } from "./AbaEditarDadosIniciaisContrato.vue?vue&type=template&id=4ddb97d6"
import script from "./AbaEditarDadosIniciaisContrato.vue?vue&type=script&lang=ts"
export * from "./AbaEditarDadosIniciaisContrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports